export default __webpack_public_path__ + "static/media/logo.bfba1fb4.png";